<script>

import Footer from './Footer.svelte'
import Title from './Title.svelte'
let title ="Coffee, Bagel, Data";
// let route = "#/FishSETMap";
let projectList = [
        {title: "FishSET Map Viewer",
        img:"images/FishSET_small.png",
        route: "#/FishSETMap",
        alt: "Image of Map"},
        {title: "TSA Checkpoint Comparison",
        img:"images/TSA_small.png",
        route: "#/TSACheckpoint",
        alt:"graph of TSA 2020 and 2019"},
        {title: "Vessel Map",
        img:"images/spire_small.png",
        route: "#/VesselMap",
        alt: "Image of Map"},
        // {title: "Data Quality Mapping Application",
        // img :"images/parkmap1.png",
        // route: "#/FishSETMap"},
        // {title: "Animating Spatial Data",
        // img:"images/mapLA_animation_speed.png",
        // route: "#/FishSETMap"},
        // {title:"Algorithm development",
        // img:"images/alg.png",
        // route: "#/FishSETMap"},
        // {title:"Data Analytics, Statistics, Metrics",
        // img:"images/ken.png",
        // route: "#/FishSETMap"},
        // {title:"Website Analytics",
        // img:"images/weban.png",
        // route: "#/FishSETMap"},
        {title:"Coffee, Bagel, Data",
        img:"images/site_small.png",
        route: "#/How",
        alt: "Image of this website"}
        // {title:"Cloud Infrastructure",
        // img:"images/site.png"},
        // {title:"NOAA Fisheries Integrated Toobox",
        // img:"images/weban.png"},
        // {title:"Spatial Economics Toolbox for Fisheries",
        // img:"images/weban.png"},
        // {title:"Cruises, Lab, and Field Work",
        // img:"images/weban.png"},
        // {title:"Data Extraction and Pipeline",
        // img:"images/weban.png"},
        // {title:"Research",
        // img:"images/weban.png"}
    ]



</script>

<Title title = {title}/>

            <article>
                <section class="about">

                    <h3> Mornings are perfect for grabbing a cup of coffee, a fresh bagel, and a new dataset.  </h3>
                    <p> I enjoy creating data visualizations and exploring data.  This site features some of these explorations.  Sometimes these experiments result in full projects or applications.  Sometimes they are just small projects to try out a new idea.  There are also general descriptions of projects I have done over the years in my career.  My experience extends across observational oceanography, scientific research, mathematics, software engineering, data analytics, spatial and temporal statistics, and mapping. </p>
                </section>
                <section class="top">

                            <img id="live" src="images/spire.png" alt="Map of vessel locations globally">

                        <div class="intro">
                            <p>
                                I have always loved maps. I remember when I was young, sitting on the floor flipping through old atlas for hours. I originally started creating mapping applications in Matlab using Rich Palowitz <a href="https://www.eoas.ubc.ca/~rich/map.html#Citation">M_Map</a> library. That was before Matlab created its own library. My work creating oceanographic mapping interfaces in Matlab started my journey of data visualizations combined with scientific integrity. At some point, I realized that the beauty, colors, and user experience of visualization was not merely an art but affected individuals’ understanding and interest in the information presented. I try to focus on the story the data needs to tell. One dataset has thousands of different hidden stories.
                            </p>

                            <p>
                                Since my early oceanography days, I have moved on to using a variety of programming languages and tools for software, data analytics, and visualization. My current go-to's are  <a href="https://docs.mapbox.com/mapbox-gl-js/api/">Mapbox GL JS</a>, <a href="https://d3js.org/ ">D3.js </a> for visualization with Python for analytics. This site is built using <a href="https://svelte.dev/Svelte.js">Svelte</a>  as a venue to try out a new Javascript framework.
                            </p>
                        </div>

                </section>

                <section class="proj">
                    <h3>Projects</h3>
                    <ul>
                        {#each projectList as { title, img, route, alt }}

                        <li>
                             <h4> <a href="{route}">{title}</a></h4>
                            <img src={img}  alt = "{alt}">

                        </li>
                        {/each}

                    </ul>
                </section>

            </article>

                <!-- <PaintMenu/> -->

        <!-- <PaintSplat/> -->
        <Footer/>
<!-- </main> -->


<style>




    article {
        background-color: #4D4E4F;
        display: flex;
        flex-direction: column;
        color: white;
        font-family:Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif;

    }
    .intro{
        display: flex;
        flex-direction:column;
        margin:auto;
        padding-top: 5px;
        padding-bottom: 5px;


    }



    .about{
        padding:10px;
        flex-shrink: 1;
        min-height: 70px;

    }





    section{

        border-bottom: 1px solid white;
        /*min-height: 200px;*/
    }
    .top{

        display: flex;
        align-items: flex-start;
        flex-direction:row;
    }
    #live{
        width:50vw;


    }

    p{padding: 0 40px;
    text-align: justify;
    margin-right:40px;
font-size: 18px}

    h3{
        text-align: center;
    }

    ul{
        list-style: none;
        display: flex;
        flex-direction:row;
        flex-wrap: wrap;

    /*overflow-x: scroll;*/
    }
    li{
        margin:10px;
        /*max-width: 250px;*/
        height: 200px;
        width: 225px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        border:3px solid #e6e6f0;

    }

    h4{background-color: #e6e6f0;
        color:black;
        margin:0;
        min-height: 40px;
        vertical-align: middle;
        text-align: center;
        }

     a{
        font-style:  italic;
        color: white;

    }
    h4 a {color:black;}
    img{ width: 200px; margin:auto;}



    @media (max-width: 900px) {
        /*body {
            max-width: none;
        }*/
        .top{
            /*max-height: 200px;*/
            flex-direction: column;
        }
        #live{
            margin: auto;
            width: 100vw;
        }
        p{
            margin:5px;
        }

    }
</style>